import { IShelf } from 'interface/showcase';
import { useEffect, useState } from 'react';

import CardUpsell from './CardUpsell';

import { Box } from '@material-ui/core';
import Carousel from '../../Carousel';
import { IS_APP } from 'settings';
import showcaseService from 'services/showcase';
import { IUpsell } from 'interface/upsell';

interface IProps {
  shelf?: IShelf;
}

const OffersShelf = (props: IProps) => {
  const [loading, setLoading] = useState(true);
  const [offers, setOffers] = useState<IUpsell[]>(null);

  useEffect(() => {
    setLoading(true);
    showcaseService
      .getShowcaseOffers()
      .then(setOffers)
      .then(() => setLoading(false));
  }, []);

  if ((offers === null && !loading) || IS_APP) return null;

  const isEmpty = (offers ?? []).length === 0;
  const loadingShelf = isEmpty && loading;
  return (
    <Box marginBottom={14} component='section'>
      <Carousel title={props.shelf.title} loadingShelf={loadingShelf} isEmpty={isEmpty}>
        {(offers ?? []).map((upsell, index) => (
          <CardUpsell key={index} upsell={upsell} />
        ))}
      </Carousel>
    </Box>
  );
};

export default OffersShelf;
